import { COHESION_CONFIG } from "@/constants/cohesion-config";
import clientSide from "@/helpers/clientSide";
import {
  TAGULAR_EVENT_TYPES,
  TAGULAR_VALUES_PROVIDED_EVENT,
} from "@/types/tagular";
import { trackError } from "../newrelic";

/**
 * Utility: fireValuesProvided
 *
 * @see {@link https://app.make.rvapps.io/schemas/sch_1uzdlRKuCuQ2QeBySglIuzXkLFy | ValuesProvided Schema}
 */
const fireValuesProvided = (
  eventOptions: TAGULAR_VALUES_PROVIDED_EVENT,
  callback?: () => void
) => {
  const { requestId, returnValues, payload } = eventOptions;
  if (returnValues.length === 0) {
    return;
  }

  const cohesionIds = clientSide
    ? {
        anonymousId: window._Cohesion?.anonymousId ?? "",
        sessionId: window._Cohesion?.sessionId ?? "",
        instanceId: window._Cohesion?.instanceId ?? "",
      }
    : {
        anonymousId: "",
        sessionId: "",
        instanceId: "",
      };

  const body: Record<string, unknown> = {
    event: TAGULAR_EVENT_TYPES.VALUES_PROVIDED,
    properties: {
      requestId,
      ...cohesionIds,
      returnValues,
      sourceId: process.env.NEXT_PUBLIC_MONARCH_SOURCE_ID,
      payload,
    },
    messageId: requestId,
  };

  if (!COHESION_CONFIG.tagular?.apiHost) return;

  fetch(COHESION_CONFIG.tagular?.apiHost, {
    method: "POST",
    headers: {
      Authorization: `Basic ${btoa(process.env.NEXT_PUBLIC_TAGULAR_WRITE_KEY + ":")}`,
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (!response.ok) {
        trackError(
          new Error(
            `Post request to Tagular proxy not successful: ${response.status}`
          )
        );
      }
    })
    .catch((error) => {
      trackError(new Error(`Post to Tagular proxy failed: ${error}`));
    });

  // Click Handler
  if (typeof callback === "function") {
    callback?.();
  }
};

export default fireValuesProvided;
